export default "__VITE_ASSET__Br5DeabJ__"